import styled from "styled-components/macro";

export const PartnersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(12.5rem, 1fr));
  grid-gap: 3rem;
  grid-row-gap: 4rem;
`;

export const Partner = styled.div`
  //background: ${(props) => `url(${props.data})`};
  width: 100%;
  //min-height: 12.5rem;
  //background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 75%;
    filter: saturate(1);
  }

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      img {
        filter: saturate(1);
      }
    }
    img {
      filter: saturate(0);
      //transition: filter 0.25s;
    }
  }
`;
